module.exports = __webpack_public_path__ + "static/media/loginBg.5ec8133f.jpg";